exports.list = {
    path: '/neraca',
    name: 'neraca', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/neraca/List.vue"),
  }
  